module.exports = {
  playing: [
    {
      name: "Tom Clancy's Ghost Recon® Breakpoint",
      imageURL: "https://store-images.s-microsoft.com/image/apps.42343.66828190550422385.db1e8db2-3853-42e9-b3d4-23771b4cf668.20c30a66-8ec1-454f-a09c-d277f38f4c76",
    },
    {
      name: "Far Cry® New Dawn",
      imageURL: "https://store-images.s-microsoft.com/image/apps.64306.64841033704503268.bc0de57e-6dcd-40b5-b35e-f9f46b4ec1ae.f10b3597-c0ec-428e-9266-d457abfd1d56?mode=scale&q=90&h=300&w=200",
    },
    {
      name: "F1™ 2015",
      imageURL: "https://store-images.s-microsoft.com/image/apps.6207.69301240788346750.e5150c02-2bc8-4179-8b86-330ac9362f56.5ea0a9c5-d47e-400e-83f0-7ec9f1febcaf?mode=scale&q=90&h=300&w=200",
    },
    {
      name: "ARK: Survival Evolved",
      imageURL: "https://store-images.s-microsoft.com/image/apps.59714.67854144654891351.62e8ac86-d08d-4b3e-a943-500d5e0b2692.84297a79-9d0e-4de5-85b0-e08169607845?mode=scale&q=90&h=300&w=200",
    },
    {
      name: "Call of Duty®: WWII",
      imageURL: "https://store-images.s-microsoft.com/image/apps.26312.70628478259232551.a0089f3a-b3b5-4c4b-bdaf-0d97810a4816.772b3a20-259a-4178-be6f-3db7bcdc9830?mode=scale&q=90&h=300&w=200",
    },
    {
      name: "Watch Dogs®",
      imageURL: "https://store-images.s-microsoft.com/image/apps.51441.66583679601418453.329e8674-c508-4106-8a82-e4ebbbda5bd7.d28372d0-95e3-4c53-aa88-43909b44308f?mode=scale&q=90&h=300&w=200",
    },
    {
      name: "Halo 5: Guardians",
      imageURL: "https://store-images.s-microsoft.com/image/apps.10920.69279545232152045.f1a4a87c-fcc9-4b7c-a620-f6c56eb2d5ad.537d404f-d551-430c-8000-9a4c657bf354?mode=scale&q=90&h=300&w=200",
    },
  ],

  played: [],
  
  remastered: [],

  classics: [],
};
